//Prime react
import { TabView, TabPanel } from "primereact/tabview"

//Styles
import FormBuilderElements from "./FormBuilderElements"
import FormBuilderOutline from "../FormBuilderOutline"

export default function FormBuilderElementsContainer({
  questionOrders,
  onOutlineSelect,
  disabled,
}) {
  return (
    <TabView className={`formTabView`}>
      <TabPanel header="Elements">
        <FormBuilderElements disabled={disabled} />
      </TabPanel>
      <TabPanel header="Outline">
        <FormBuilderOutline
          questionOrders={questionOrders}
          onElementSelect={onOutlineSelect}
        />
      </TabPanel>
    </TabView>
  )
}
